import React from 'react';
import SidebarMenu from "../../components/SidebarMenu/SidebarMenu";
import Map from "../../components/Map/Map";
import {useHistory, useParams} from "react-router";
import {showEditingAlert} from "../../store/modalsSlice";
import {connect} from "react-redux";
import {makeStyles} from "@material-ui/core";
import useMediaQuery from '@material-ui/core/useMediaQuery';

const drawerWidth = 350;
const useStyles = makeStyles(theme => ({
	Drawer: {
		width: drawerWidth,
		flexShrink: 0
	},
	DrawerPaper: {
		width: drawerWidth,
	},
	DrawerSmall: {
		width: '100%'
	},
	DrawerPaperSmall: {
		width: '100%'
	}
}));

const MainScreen = (props) => {
	const {alertId} = useParams();
	const history = useHistory();
	const css = useStyles();
	const isSmall = useMediaQuery('(max-width:600px)');

	if( alertId ) {
		console.log("Setting alert to " + alertId);
		const alert = props.alerts.find(a => a.alert_id === +alertId);
		if( !alert ) {
			window.alert("Can't find this alert.");
			history.push("/");
		}

		props.showEditingAlert(alert);
	}

	return (
		<>
			<SidebarMenu drawerClass={isSmall ? css.DrawerSmall : css.Drawer} paperClass={isSmall ? css.DrawerPaperSmall : css.DrawerPaper} />
			{isSmall ? null : <Map
				loadingElement={<div style={{ height: "100%", width:"100%" }} />}
				containerElement={<div style={{ height: "100%", width:"100%" }} />}
				mapElement={<div style={{ height: "100%", width:"100%" }} />}
			/>}
		</>
	);
};

const mapStateToProps = (state) => {
	return {
		editingAlert: state.modals.editingAlert,
		alerts: state.notifications.alerts
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		showEditingAlert: (val) => dispatch(showEditingAlert(val))
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(MainScreen);